module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/flask-21a8d43d81eeee3474deb2e8f2457c27.svg";